export const baseEvent = {
  context: 'PROPERTY_SALE',
} as const

export enum BaseEventTypes {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}
